import React, {useRef} from 'react'
import {useInputValue} from '@modifi/plugin-forms'
import {
  TRADE_PARTNER_COUNTRY_CODE,
  TRADE_PARTNER_ZIP_CODE,
  ZipCode,
} from '@modifi/plugin-onboarding'
import {useSelector} from '@modifi/redux'
import {selectCountryZipCodePatternByAlpha2} from '@modifi/plugin-countries'
import {useTranslation} from '@modifi/plugin-i18n'

import {getSampleStringsFromRegex} from '../../utils/generate-sample-strings-from-regex'

export const CustomZipCode: React.FC<{}> = props => {
  const {value: zipCode} = useInputValue({name: TRADE_PARTNER_ZIP_CODE})
  const {value: countryCode} = useInputValue({name: TRADE_PARTNER_COUNTRY_CODE})
  const {t} = useTranslation('plugin-forms')

  const zipCodePattern = useSelector(state =>
    selectCountryZipCodePatternByAlpha2(state, countryCode)
  )

  const disableRef = useRef(true)

  if (!zipCode || !new RegExp(zipCodePattern).test(zipCode as string)) {
    disableRef.current = false
  }

  const sampleZipCodes = zipCodePattern
    ? getSampleStringsFromRegex(zipCodePattern)?.join(' , ')
    : []

  return (
    <ZipCode
      {...props}
      required
      {...(disableRef.current ? {} : {disabled: false})}
      // @ts-expect-error to be fixed in source
      matchMessage={t('zip-code.validation.error-message', {sampleZipCodes})}
    />
  )
}
